var primitiveButton = 'fx_2d2fb1e5_163p7g20';
var primitiveButtonClickableVariants = {weak:'fx_2d2fb1e5_163p7g21','default':'fx_2d2fb1e5_163p7g22',strong:'fx_2d2fb1e5_163p7g23',none:'fx_2d2fb1e5_163p7g24'};

export { primitiveButton, primitiveButtonClickableVariants };
//# sourceMappingURL=primitiveButton.vanilla.mjs.map
